import { useColorSlider } from "@react-aria/color"
import { useFocusRing } from "@react-aria/focus"
import { useLocale } from "@react-aria/i18n"
import {
  type ColorSliderStateOptions,
  useColorSliderState,
} from "@react-stately/color"
import { VisuallyHidden } from "radix-ui"
import { useRef } from "react"

import styles from "./ColorSlider.module.css"

type Props = Omit<ColorSliderStateOptions, "locale" | "channel">

export function ColorSlider(props: Props) {
  const { locale } = useLocale()

  const colorSliderStateOptions = {
    ...props,
    locale,
    channel: "hue",
  } as const

  const state = useColorSliderState(colorSliderStateOptions)
  const trackRef = useRef(null)
  const inputRef = useRef(null)

  const { trackProps, thumbProps, inputProps } = useColorSlider(
    {
      ...colorSliderStateOptions,
      trackRef,
      inputRef,
    },
    state,
  )

  const { focusProps } = useFocusRing()

  return (
    <div className={styles.root}>
      <div
        {...trackProps}
        ref={trackRef}
        className={styles.track}
        style={trackProps.style}
      >
        <div
          {...thumbProps}
          className={styles.thumb}
          style={{
            ...thumbProps.style,
            background: state.getDisplayColor().toString("css"),
          }}
        >
          <VisuallyHidden.Root>
            <input {...inputProps} {...focusProps} ref={inputRef} />
          </VisuallyHidden.Root>
        </div>
      </div>
    </div>
  )
}
